const FILE_UPLOAD_SIZE = 5 * 1024 * 1024; // 5MB;

export {
  FILE_UPLOAD_SIZE,
};
